var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('weather'),_c('oil-list',{attrs:{"id":"list"}}),_c('div',{staticClass:"freshButton",on:{"click":_vm.refresh}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }